export const StoreConsts = {
  STATUS_ACTIVE: 1,
  STATUS_INACTIVE: 2,
  getStatusName: (status: number): string => typeof statuses[status] != 'undefined' ? statuses[status] : ''
}

const statuses: Record<number, string> = {
  [StoreConsts.STATUS_ACTIVE]: 'Hoạt động',
  [StoreConsts.STATUS_INACTIVE]: 'Không hoạt động'
}


export interface IBusiness {
  id: number;
  name: string;
  email: string;
  status: number;
}

export interface IBusinessOption {
  id: number,
  name: string,
  roleId?: string,
  pageIds: string[]
}
